module.exports = __webpack_public_path__ + "f6e3b5b5ec86c54e9a075281d6773f96.png";